import { observable, action, useStrict, runInAction, autorun, flow, set, toJS } from 'mobx';
import {
  isEmpty,
  isArray,
  cloneDeep,
  filter,
  merge,
  get,
  includes,
  has,
  pick,
  isUndefined,
  isNull
} from 'lodash';
import { Toast } from 'antd-mobile';
import Serv from './ProfitSharingServ';

class ProfitSharingMod {
  @observable bindInfo = {
    bindingTime: '', //绑定时间	string($date-time)
    createTime: '', //购买时间
    giftCode: '', // 礼包编码
    periodTime: '', //有效期
    shopCode: '', //	绑定店铺
    status: '' //绑定状态(1未购买，2已购买，3审核中，4已绑定)
  };

  notificationStatus = flow(function* (cardCode) {
    try {
      const res = yield Serv.notificationStatus(cardCode);
      if (res.resultCode == '0') {
        this.bindInfo = res.data;
      }
      console.log(res);
    } catch (error) {}
  });
}
const profitSharingMod = new ProfitSharingMod();
export default profitSharingMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/ProfitSharing/ProfitSharingMod.js